import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  let list: any[] = []
  if (data?.cardSchemeRespList?.length > 0) {
    data?.cardSchemeRespList?.map((item) => {
      list.push({
        type: item.cardType,
        scheme: item.cardScheme,
        description: item.description,
      })
    })
  }
  return list
}

const getCardSchemesListApi = (tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: `${APIEndPoints.getCardSchemeList}`,
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getCardSchemesListApi }
